/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ExtNotFoundPageComponent } from '@gh/common-external-shared';
import { createRoute } from '@gh/common-shared';
import { SupplierCalendarComponent, SupplierInvoicesListComponent, SupplierPurchaseOrderListComponent, SupplierSharedDocsListComponent, } from './components';
import { SupplierOfficeActivator } from './resources';
import { getSupplierBootstrapParams } from './supplier-app.utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var routes = [{
        path: 'accept-invitation/:officeId',
        canActivate: [SupplierOfficeActivator],
        data: {
            isAcceptInvitation: true,
        },
        // empty children is necesary here to workaround @angular/router problem:
        // it does not allow to use route without component/children/loadChildren/redirectTo
        // it is not a problem here, as we never load this route (CanActivate always return false)
        children: [],
    }, {
        path: '',
        pathMatch: 'full',
        canActivate: [SupplierOfficeActivator],
        children: [],
    }, {
        path: 'offices/:officeId',
        canActivate: [SupplierOfficeActivator],
        runGuardsAndResolvers: 'always',
        children: [
            createRoute({
                path: 'purchase-orders',
                pathMatch: 'full',
                component: SupplierPurchaseOrderListComponent,
            }),
            createRoute({
                path: 'shared-docs',
                pathMatch: 'full',
                component: SupplierSharedDocsListComponent,
            }),
            createRoute({
                path: 'calendar',
                pathMatch: 'full',
                component: SupplierCalendarComponent,
            }),
            createRoute({
                path: 'invoices',
                pathMatch: 'full',
                component: SupplierInvoicesListComponent,
            }),
        ],
    }, {
        path: '404',
        component: ExtNotFoundPageComponent,
    }, {
        path: '**',
        component: ExtNotFoundPageComponent,
    }];
var SupplierAppRoutingModule = /** @class */ (function () {
    function SupplierAppRoutingModule() {
    }
    SupplierAppRoutingModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupplierAppRoutingModule });
    SupplierAppRoutingModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SupplierAppRoutingModule_Factory(t) { return new (t || SupplierAppRoutingModule)(); }, providers: [{
                provide: APP_BASE_HREF,
                useValue: getSupplierBootstrapParams().baseUrl,
            }], imports: [[RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
            RouterModule] });
    return SupplierAppRoutingModule;
}());
export { SupplierAppRoutingModule };
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SupplierAppRoutingModule, { imports: [i1.RouterModule], exports: [RouterModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierAppRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
                providers: [{
                        provide: APP_BASE_HREF,
                        useValue: getSupplierBootstrapParams().baseUrl,
                    }],
                declarations: [],
                exports: [RouterModule],
            }]
    }], null, null); })();
